import tccf7Load from './tccf7Load.js';
import tccf7Observer from './tccf7Observer.js';
import tccf7StateManager from './tccf7StateManager.js';
import tccf7EventManager from './tccf7EventManager.js';
import tccf7ButtonController from './tccf7ButtonController.js';
import tccf7HoneyPot from './tccf7HoneyPot.js';
import tccf7Confirm from './tccf7Confirm.js';
import tccf7Complete from './tccf7Complete.js';
import { tccf7Logger } from './tccf7ErrorHandler.js';
import { TCCF7_CONFIG } from './tccf7Constants.js';

/*-------------------------------------------------------------------------------

  init tccf7

--------------------------------------------------------------------------------*/
export default class tccf7 {  
  constructor( elem ) {
    if ( ! elem ) return;

    this.elem   = elem;
    this.id     = elem.id;
    this.form   = elem.querySelector( 'form' );
    if ( ! this.form ) return;

    this.formIdInput = this.elem.querySelector('[name="_wpcf7"]');
    this.formId      = this.formIdInput 
      ? this.formIdInput.value 
      : ( this.form.getAttribute('id') || this.id );
    if ( ! this.formId ) return;

    this.btnClass = TCCF7_CONFIG.SELECTORS.BTN;

    this.tccf7ConfirmStart  = false;
    this.tccf7CompleteStart = false;
    this.tccf7HoneyPotStart = false;

    this.init();
  }

  /*----------------------------------------
    初期化関数
  ------------------------------------------*/
  init() {
    this.stateManager = tccf7StateManager.getInstance(this.formId, this.form);
    this.eventManager = tccf7EventManager.getInstance(this.formId);
    this.eventManager.registerBeforeSubmit(this.form);
    this.tccf7ButtonController = tccf7ButtonController.getInstance(this.formId, this.form);
    // 初回処理
    this.tccf7Load = new tccf7Load(this.elem);
    // 各タグ
    this.tccf7HoneyPot      = new tccf7HoneyPot(this.formId, this.form);
    this.tccf7HoneyPotStart = this.tccf7HoneyPot.start;
    this.tccf7Complete      = new tccf7Complete(this.formId);
    this.tccf7CompleteStart = this.tccf7Complete.start;
    this.tccf7Confirm       = new tccf7Confirm(this.formId , this.form, this.tccf7CompleteStart);
    this.tccf7ConfirmStart  = this.tccf7Confirm.start;
    
    if(this.tccf7CompleteStart){
      this.stateManager.setRedirect(true);
    }

    this.eventManager.on('beforesubmit', () => {
      this.tccf7ButtonController.setSubmitting();
    });

    this.eventManager.on('invalid', (e) => {
      this.stateManager.setValidate(true);
      this.tccf7ButtonController.setFailed();
      this.form.classList.add('tccf7-show-response-output');
      tccf7Logger.showUserError(TCCF7_CONFIG.MESSAGE.SUBMIT_ERROR, this.form);
    });

    this.eventManager.on('mailsent', () => {
      this.stateManager.setValidate(false);
      this.tccf7ButtonController.setCompleted();
      this.form.classList.remove('tccf7-show-response-output');
      tccf7Logger.clearUserError(this.form);
    });

    this.eventManager.on('mailfailed', () => {
      this.tccf7ButtonController.setFailed();
      tccf7Logger.showUserError(TCCF7_CONFIG.MESSAGE.SUBMIT_ERROR, this.form);
    });

    this.eventManager.on('ajaxerror', () => {
      this.tccf7ButtonController.setFailed();
      tccf7Logger.showUserError(TCCF7_CONFIG.MESSAGE.NETWORK_ERROR, this.form);
    });
    
    // 監視セット
    this.setObserver();
  }

  /*----------------------------------------
    フォーム：内容変更を監視・状態チェックや更新を自動で行う
  ------------------------------------------*/
  setObserver() {
     new tccf7Observer(this.elem, () => this.tccf7ButtonController.updateRefs(this.elem));
  }

}